module.exports = __webpack_public_path__ + "static/media/data.20950c36.csv";